<style lang="scss" scoped>
.d-flex {
  height: calc(100vh - 200px);
}

@media (min-width: 992px) {
  .card {
    width: 500px;
  }
}
@media (max-width: 991px) {
  .card {
    max-width: 300px;
  }
}
</style>

<template>
  <div class="d-flex justify-content-around align-items-center">
    <div>
      <div class="card">
        <form @submit.prevent="login()" action="">
          <div class="card-header">
            <h4 class="card-title">
              Anmeldung
            </h4>
          </div>
          <div class="card-body">
            <div class="form-group">
              <label>E-Mail-Adresse oder Benutzername</label>
              <fg-input
                type="text"
                name="email"
                v-model="credentials.email"
              ></fg-input>
            </div>
            <div class="form-group">
              <label>Passwort</label>
              <fg-input
                type="password"
                name="password"
                v-model="credentials.password"
              ></fg-input>
            </div>
            <fg-input
              type="hidden"
              value=""
              name="window_height"
              id="window_height"
            />
            <fg-input
              type="hidden"
              value=""
              name="window_width"
              id="window_width"
            />
            <fg-input
              type="hidden"
              value=""
              name="pixel_ratio"
              id="pixel_ratio"
            />
            <fg-input
              type="hidden"
              value=""
              name="screen_height"
              id="screen_height"
            />
            <fg-input
              type="hidden"
              value=""
              name="screen_width"
              id="screen_width"
            />
          </div>
          <div class="card-footer text-center">
            <p-button :working="working" type="info" nativeType="submit"
              >Einloggen</p-button
            >
          </div>
        </form>
      </div>
      <div v-if="authExpired" class="alert alert-danger">
        <span>Deine Sitzung ist abgelaufen.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      credentials: {
        email: "",
        password: ""
      },
      working: false,
      window_height: null,
      window_width: null,
      pixel_ratio: null,
      screen_height: null,
      screen_width: null
    };
  },
  created() {
    this.window_height = window.innerHeight;
    this.window_width = window.innerWidth;
    this.pixel_ratio = window.devicePixelRatio;
    this.screen_width = window.screen.width;
    this.screen_height = window.screen.height;
  },
  computed: {
    authExpired() {
      return "authExpired" in this.$route.query;
    }
  },
  methods: {
    login() {
      this.$http
        .post("/login", {
          ...this.credentials,
          window_height: this.window_height,
          window_width: this.window_width,
          pixel_ratio: this.pixel_ratio,
          screen_width: this.screen_width,
          screen_height: this.screen_height
        })
        .then(() => {
          window.location = "/";
          this.working = false;
        })
        .catch(({ response }) => {
          this.$notify({
            title: response.data.errors.email[0],
            type: "error"
          });
          this.working = false;
        });
    }
  }
};
</script>
